export default __webpack_public_path__ + "static/media/nu.0daf5b0d.jpg";